module.exports = __webpack_public_path__ + "static/img/005.7356de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/005.png
// module id = mnmo
// module chunks = 0